module.exports = __webpack_public_path__ + "img/ri_hotel-line-blue.423f253b.svg";